import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewOvertimeRequestModal from 'modules/attendance/components/ClockIn/Modals/OvertimeRequest/New'

const NewOvertimeRequestPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { year, month, day, employeeId, periodType } = useStrictParams<
    'year' | 'month' | 'day' | 'employeeId' | 'periodType'
  >()

  const onClose = () => {
    navigate(
      navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.fullPath({
        periodType,
        year,
        month,
        day,
        employeeId,
      })
    )
  }

  return <NewOvertimeRequestModal employeeId={Number(employeeId)} onClose={onClose} />
}

export default NewOvertimeRequestPage
